import { Service } from '@/tools'
export class ChannelService<T extends TCommodity.Channel> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }
  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Channel}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  queryLimitPriceList = (data: T['ApiQueryLimitPriceList']): Promise<T['ApiQueryLimitPriceList']['res']> =>
    this.post2('v1/ApiQueryLimitPriceList', data)
}
